import { DESIGN_PROJECT_ID } from './designFixtures';
import { WORKFLOW_TEMPLATE_IDS } from './workflowTemplates';

/**
 * Compile-time design mode (set by `npm run design` via REACT_APP_DESIGN_MODE).
 */
export const isDesignMode = () =>
  process.env.REACT_APP_DESIGN_MODE === 'true';

export const isDesignCanvasProject = (projectId) =>
  isDesignMode() &&
  (projectId === DESIGN_PROJECT_ID || WORKFLOW_TEMPLATE_IDS.has(projectId));

/** JWT with far-future exp; jwtDecode only, not verified against a secret. */
export const DESIGN_JWT =
  'eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJzdWIiOiJkZXNpZ24iLCJleHAiOjk5OTk5OTk5OTl9.lcYZNZcjw0Vk85PL9vrUzrFPQu_SMvBOz5x98mti8U';

export const DESIGN_USER = {
  email: 'design@local.dev',
  avatar: null,
};
